import { createSlice } from "@reduxjs/toolkit";
import { takeLatest, put, call } from "redux-saga/effects";

const appConfigSlice = createSlice({
  name: "appConfig",
  initialState: {
    configData: {},
    configurationData: {},
    benefitsAndFeatures: {},
    invoiceTitle: {},
    loading: false,
    error: null,
    message: null,
  },
  reducers: {
    getAppConfig: (state) => {
      state.loading = true;
    },
    getAppConfigSuccess: (state, action) => {
      state.configData = action.payload;
      console.log("state.configData ", state.configData);
      state.loading = false;
      state.message = "Fetched configuration successfully.";
    },
    getAppConfigFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getBenefitsAndFeatures: (state) => {
      state.loading = true;
    },
    getBenefitsAndFeaturesSuccess: (state, action) => {
      state.benefitsAndFeatures = action.payload;
      //console.log("state.configData ", state.configData);
      state.loading = false;
      state.message = "Fetched  Benefits And Features successfully.";
    },
    getBenefitsAndFeaturesFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearMessage: (state) => {
      state.error = null;
      state.message = null;
    },
    updateConfigRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    updateConfigSuccess: (state, action) => {
      state.loading = false;
      state.message = "Configuration saved successfully";
      const { key, value } = action.payload;
      state.configData[key] = value;
    },
    updateConfigFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getConfiguration: (state) => {
      state.loading = true;
    },
    getConfigurationSuccess: (state, action) => {
      state.configurationData = action.payload;
      state.loading = false;
      state.message = "Configuration loaded successfully.";
    },
    getConfigurationFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateSingleConfigRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateSingleConfigSuccess: (state, action) => {
      state.loading = false;
      state.message = "Single setting updated successfully";
      const { key, value } = action.payload;
      state.configurationData[key] = value;
    },
    updateSingleConfigFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveAddressRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    saveAddressSuccess: (state, action) => {
      state.loading = false;
      state.message = "Address saved successfully";
      state.configurationData.address = action.payload; // optional
    },
    saveAddressFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveFirebaseSettingRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    saveFirebaseSettingSuccess: (state, action) => {
      state.loading = false;
      state.message = "Firebase setting saved successfully";
    },
    saveFirebaseSettingFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveAdminFirebaseSettingRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    saveAdminFirebaseSettingSuccess: (state, action) => {
      state.loading = false;
      state.message = "Admin Firebase setting saved successfully";
    },
    saveAdminFirebaseSettingFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getInvoiceTitleRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getInvoiceTitleSuccess: (state, action) => {
      state.loading = false;
      state.invoiceTitle = action.payload;
      state.message = "Invoice title fetched successfully";
    },
    getInvoiceTitleFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getAppConfig,
  getAppConfigSuccess,
  getAppConfigFailure,
  getBenefitsAndFeatures,
  getBenefitsAndFeaturesSuccess,
  getBenefitsAndFeaturesFailure,
  clearMessage,
  updateConfigRequest,
  updateConfigSuccess,
  updateConfigFailure,
  getConfiguration,
  getConfigurationSuccess,
  getConfigurationFailure,
  updateSingleConfigRequest,
  updateSingleConfigSuccess,
  updateSingleConfigFailure,
  saveAddressRequest,
  saveAddressSuccess,
  saveAddressFailure,
  saveFirebaseSettingRequest,
  saveFirebaseSettingSuccess,
  saveFirebaseSettingFailure,
  saveAdminFirebaseSettingRequest,
  saveAdminFirebaseSettingSuccess,
  saveAdminFirebaseSettingFailure,
  getInvoiceTitleRequest,
  getInvoiceTitleSuccess,
  getInvoiceTitleFailure,
} = appConfigSlice.actions;

export default appConfigSlice.reducer;
